import { gql } from "@apollo/client";

export const CREATE_PLAYLIST = gql`
  mutation CreatePlaylist(
    $accountId: Int!
    $title: String!
    $voiceMessageIds: [Int!]!
    $startOn: String!
    $endOn: String!
    $isFreeTrial: Boolean!
    $isTracked: Boolean!
  ) {
    createPlaylist(
      data: {
        accountId: $accountId
        title: $title
        voiceMessageIds: $voiceMessageIds
        startOn: $startOn
        endOn: $endOn
        isFreeTrial: $isFreeTrial
        isTracked: $isTracked
      }
    ) {
      id
      title
      startOn
      endOn
      createdOn
      updatedOn
      program {
        id
        round
        program_type
      }
    }
  }
`;
